import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './lang/zhcn.json' // 中文语言包
import en from './lang/enus.json' // 英文语言包
import th from './lang/thth.json' // 泰语

Vue.use(VueI18n) // 全局挂载

export const locales = {
  zhcn: 'zh',
  enus: 'en',
  thth: 'th'
}
export const i18n = new VueI18n({
  locale: 'zh', // 默认中文
  messages: {
    zh,
    en,
    th
  }
})

export default i18n
